import logoutUser from 'utils/logoutUser'

//import actions
import { unsetIsLoadingApp } from 'modules/app'
import { setTypeModal, toggleOpenModal, setTextModal } from 'modules/modal'

// User-facing message shown when AWS WAF (at the CloudFront edge) blocks a request
// based on the body's content or size. We deliberately avoid exposing any raw
// WAF/CloudFront detail and give the user an actionable next step instead.
export const EDGE_SECURITY_BLOCK_MESSAGE = 'This file couldn\'t be uploaded because its contents were blocked by a security filter. Try re-saving or re-exporting the file (for example, "Print to PDF") and upload it again. If the problem continues, please contact us at nexus@ielfreight.com.'

/**
 * Detects a 403 that originated from the CloudFront/WAF edge rather than the API.
 *
 * A CloudFront/WAF block never reaches the backend: it returns CloudFront's HTML
 * error page ("The request could not be satisfied ... Generated by cloudfront")
 * with a text/html content-type. A genuine API 403 returns JSON with a `message`.
 * CORS can hide custom response headers, so the HTML body / content-type sniff is
 * the most reliable signal.
 */
export function isEdgeSecurityBlock (error) {
	const response = error && error.response

	if (!response || response.status !== 403) {
		return false
	}

	const headers = response.headers || {}
	const contentType = headers['content-type'] || headers['Content-Type'] || ''
	const isHtml = typeof contentType === 'string' && contentType.toLowerCase().includes('text/html')

	const body = typeof response.data === 'string' ? response.data : ''
	const looksLikeCloudFront = /the request could not be satisfied|generated by cloudfront/i.test(body)

	return isHtml || looksLikeCloudFront
}

export default function handleError (error, showModal = true, customMessage) {
	return dispatch => {
		let userErrorMessage = ''; // Error message that is only displayed to the user
		let logout = false

		// HTTP status lives on error.response.status. (error.code is an axios string
		// such as 'ERR_BAD_REQUEST', never the numeric HTTP status.)
		const status = error && error.response ? error.response.status : undefined
		const edgeSecurityBlock = isEdgeSecurityBlock(error)

		// If there is a custom message set, use it
		if (customMessage) {
			userErrorMessage = customMessage;
		} else if (edgeSecurityBlock) {
			// CloudFront/WAF blocked the request at the edge based on content or size.
			// This is not a permission problem, so we do not log the user out.
			userErrorMessage = EDGE_SECURITY_BLOCK_MESSAGE;
		} else if (status === 403) {
			// A genuine permission 403 from the API — kick the user out.
			userErrorMessage = 'You are not permitted to be here. If this is by error, please contact us at nexus@ielfreight.com.'
			logout = true
		} else if (error && error.response && error.response.data && error.response.data.message) {
			userErrorMessage = error.response.data.message;
		} else if (error && error.message) {
			userErrorMessage = error.message;
		} else {
			// Fail safe just to make sure we have some sort of error to show the user.
			userErrorMessage = 'An unknown error has occured. Please reload and try again. If problem persists, please contact NEXUS@ielfreight.com.';
		}

		if (showModal) {
			if (logout === true) {
				window.location.replace('/')
				dispatch(logoutUser())
			}
			dispatch(setTypeModal(`error`))
			dispatch(setTextModal(`${userErrorMessage}`))
			dispatch(toggleOpenModal())
			dispatch(unsetIsLoadingApp())
		}
	}
}
